module.exports = __webpack_public_path__ + "img/waves-about-slider-1.c6453b79.png";